import logotrans from "../images/logotrans.png";

const InfoHomescreen = () => {
  return (
    <section className="py-12 px-6 bg-gray-100 text-center">
      <div className="flex flex-col sm:flex-row justify-center items-center space-y-8 sm:space-x-8 sm:space-y-0">
        {/* Afbeelding van het logo */}
        <div className="w-full sm:w-1/2 max-w-xs">
          <img
            src={logotrans}
            alt="Logo"
            className="w-full h-auto object-contain"
          />
        </div>

        {/* Tekst Sectie */}
        <div className="text-lg text-gray-800">
          <h2 className="text-3xl font-semibold text-gray-900 mb-6">Openingsuren</h2>
          <p className="mb-4">
            <strong>Vrijdag:</strong> Doorlopend van 8u00 tot 18u00
          </p>
          <p>
            <strong>Zaterdag:</strong> Doorlopend van 8u00 tot 18u00
          </p>
          <p className="font-semibold mt-4">
            Telefoonnummer: <a href="tel:+32477292333" className="text-red-900 hover:text-red-500">0477 29 23 33</a>
          </p>
          <p className="mt-4">
            <strong>Adres:</strong> Spijkerswegel 3, Sint-Kruis
          </p>
        </div>
      </div>
    </section>
  );
};

export default InfoHomescreen;